export default __webpack_public_path__ + "static/media/572.a271f7cb.png";